export const verificationProcess = [
  { step: 1, icon: "ri-search-eye-line", title: "1차 기초 검증", desc: "도메인 등록일, 서버 위치, SSL 인증서, 사이트 운영 기간 등 기본 정보를 확인합니다" },
  { step: 2, icon: "ri-file-search-line", title: "2차 심층 분석", desc: "환전 처리 속도, 고객센터 응대율, 이용약관 검토, 과거 이력 조회 등 심층 분석을 진행합니다" },
  { step: 3, icon: "ri-shield-user-line", title: "3차 실사 테스트", desc: "실제 이용자 테스트를 통해 환전 프로세스, 사이트 안정성, 고객 응대 품질을 직접 검증합니다" },
  { step: 4, icon: "ri-survey-line", title: "4차 커뮤니티 평가", desc: "커뮤니티 회원들의 실제 이용 후기와 평가 데이터를 종합적으로 수집하여 분석합니다" },
  { step: 5, icon: "ri-verified-badge-line", title: "최종 인증", desc: "모든 검증 단계를 통과한 사이트에 대해 보증금 예치 및 정식 인증을 완료합니다" },
];

export const recentScamReports = [
  { id: 1, siteName: "럭키존", domain: "lucky-zone.net", reportDate: "2026-06-30", issue: "환전 거부", status: "확인완료" },
  { id: 2, siteName: "골드킹", domain: "goldking-bet.com", reportDate: "2026-06-28", issue: "사이트 폐쇄", status: "검증중" },
  { id: 3, siteName: "빅윈클럽", domain: "bigwinclub.kr", reportDate: "2026-06-25", issue: "추가 입금 요구", status: "확인완료" },
  { id: 4, siteName: "프리미엄벳", domain: "premiumbet.co.kr", reportDate: "2026-06-22", issue: "잔액 몰수", status: "검증중" },
  { id: 5, siteName: "스타플레이", domain: "starplay.live", reportDate: "2026-06-20", issue: "환전 지연", status: "확인완료" },
];

export const safetyChecklist = [
  "도메인 등록일이 6개월 이상인가요?",
  "SSL 보안 인증서가 설치되어 있나요?",
  "고객센터 연락처가 명확히 표시되어 있나요?",
  "환전 정책과 수수료가 투명하게 공개되어 있나요?",
  "실제 이용자들의 최근 후기가 존재하나요?",
  "사이트 운영사의 실명 정보가 확인 가능한가요?",
];